import * as RadixToast from '@radix-ui/react-toast';
import { cn } from '@/shared/lib/cn';
import { useToastStore, type ToastTone } from './toastStore';

const toneClass: Record<ToastTone, string> = {
  info: 'border-info',
  success: 'border-success',
  warning: 'border-warning',
  danger: 'border-danger',
};

export function Toaster() {
  const items = useToastStore((s) => s.items);
  const remove = useToastStore((s) => s.remove);
  return (
    <RadixToast.Provider swipeDirection="right" duration={4000}>
      {items.map((t) => (
        <RadixToast.Root
          key={t.id}
          duration={t.action ? 10000 : undefined}
          onOpenChange={(o) => !o && remove(t.id)}
          onClick={
            t.onClick
              ? () => {
                  t.onClick!();
                  remove(t.id);
                }
              : undefined
          }
          className={cn(
            'bg-bg-elevated text-fg rounded-md border-l-4 p-3 text-sm shadow-[var(--shadow)]',
            t.onClick && 'hover:bg-bg-hover cursor-pointer',
            toneClass[t.tone],
          )}
        >
          {/* Sunucu hataları çok satırlı gelebiliyor (konum / satır / mesaj); satır
              yapısı korunmazsa hepsi tek paragrafa yapışıp okunaksız oluyor. Çok uzun
              metin toast'ı ekranı kaplayacak kadar uzatmasın diye yükseklik sınırlı. */}
          <RadixToast.Title className="max-h-64 overflow-auto font-medium whitespace-pre-line">
            {t.title}
            {t.count && t.count > 1 ? (
              <span className="text-fg-muted ml-1.5 text-xs font-normal tabular-nums">×{t.count}</span>
            ) : null}
          </RadixToast.Title>
          {t.description ? (
            <RadixToast.Description className="text-fg-muted mt-1">{t.description}</RadixToast.Description>
          ) : null}
          {t.action ? (
            <RadixToast.Action
              altText={t.action.label}
              className="text-brand-600 hover:text-brand-700 mt-1.5 text-sm font-medium underline-offset-2 hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                t.action!.onClick();
                remove(t.id);
              }}
            >
              {t.action.label}
            </RadixToast.Action>
          ) : null}
        </RadixToast.Root>
      ))}
      <RadixToast.Viewport className="fixed right-4 bottom-4 z-[60] flex w-[min(92vw,22rem)] flex-col gap-2 outline-none" />
    </RadixToast.Provider>
  );
}
